import type { IconData } from '@stacksjs/iconify-core'

export const otherUiBluetooth: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m11 8l3-3l-5-5H6v3L4 1L2 3l4 4v2l-4 4l2 2l2-2v3h3l5-5zM8.498 3.5L10 5L8.498 6.5zm0 6L10 11l-1.502 1.5z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiBluetooth
